import { Component, ElementRef, inject, input, viewChild } from '@angular/core';
import { FORM_KEYS, GameFilterService } from '../../../../services/games/game-filter.service';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { FormInputComponent } from '../../../components/form-controls/form-input/form-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-games-search',
  templateUrl: './games-search.component.html',
  styleUrls: ['./games-search.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, FormInputComponent, TranslatePipe],
})
export class GamesSearchComponent {
  gamesFilters = inject(GameFilterService);
  private _router = inject(Router);


  readonly inputRef = viewChild.required<ElementRef<HTMLInputElement>>('inputRef');

  readonly config = input<{
    isMainSearchForm: boolean;
    isGamesSearchForm: boolean;
    isSideNavSearchForm: boolean;
}>({
    isMainSearchForm: false,
    isGamesSearchForm: false,
    isSideNavSearchForm: false,
});

  public async onGoSearch() {
    await this._router.navigate(['/', 'games'], {
      queryParams: {
        [FORM_KEYS.SEARCH]:
        this.gamesFilters.state().searchFormMain.get(FORM_KEYS.SEARCH).value,
      },
      queryParamsHandling: 'merge',
    });
    if (this.gamesFilters.state().isShowSearchBar) {
      this.gamesFilters.toggleSearchPopup();
    }
  }

  public onBlurInput() {
    this.inputRef().nativeElement.blur();
  }

  public onFocusInput() {
    if (this.gamesFilters.state().isShowFiltersBar) {
      this.gamesFilters.updateShowFiltersBar(false);
    }
  }
}
